import { takeEvery, call, put, fork, all, select } from 'redux-saga/effects';
import * as apiCommon from '../services/apiCommon';
import * as apiEntity from '../services/entity/api_entity';
import {
  INVENTORY_STATUS,
  TRANSACTION_STATUS,
  DEVICE_STATUS,
  ENTITY_TYPE,
} from '../constants/constant_doc_types';
import {
  FETCH_INVENTORY_STATUS,
  FETCH_TRANSACTION_STATUS,
  FETCH_ENTITY_TYPE,
  FETCH_EMPLOYEE_ROLE_AUTHORITY_LIST,
  FETCH_ADDRESS_TYPE_LIST,
  FETCH_COUNTRY_LIST,
} from '../constants/constant_action_types';
import {
  setEntityTypeList,
  setTransactionStatusList,
  setDeviceStatusList,
  setInventoryStatusList,
  setUserRoleAuthorityList,
  setAddressTypeList,
  setCountryList,
} from '../actions/actionCreatorList';
import { DOCTYPE_ADDRESS_TYPE, DOCTYPE_COUNTRY } from '@krispsystems/constants';

export default function*(app) {
  return yield all([
    fork(fetchInventoryStatus, app),
    fork(fetchTransactionStatus, app),
    fork(fetchDeviceStatusList, app),
    fork(fetchEntityType, app),
    fork(fetchEmployeeRoleAuthority, app),
    fork(fetchAddressType, app),
    fork(fetchCountry, app),
  ]);
}

function* fetchInventoryStatus(app) {
  yield takeEvery(FETCH_INVENTORY_STATUS, fetchInventoryStatusList, app);
}

function* fetchInventoryStatusList(app) {
  const { data } = yield call(apiCommon.queryDocs, app, INVENTORY_STATUS);
  yield put(setInventoryStatusList(data));
}

function* fetchTransactionStatus(app) {
  yield takeEvery(FETCH_TRANSACTION_STATUS, fetchTransactionStatusList, app);
}

function* fetchTransactionStatusList(app) {
  const { data } = yield call(apiCommon.queryDocs, app, TRANSACTION_STATUS);
  yield put(setTransactionStatusList(data));
}

function* fetchDeviceStatusList(app) {
  const { data } = yield call(apiCommon.queryDocs, app, DEVICE_STATUS);
  yield put(setDeviceStatusList(data));
}

function* fetchEntityType(app) {
  yield takeEvery(FETCH_ENTITY_TYPE, fetchEntityTypeList, app);
}

function* fetchEntityTypeList(app) {
  const { data } = yield call(apiCommon.queryDocs, app, ENTITY_TYPE);
  yield put(setEntityTypeList(data));
}

function* fetchEmployeeRoleAuthority(app) {
  yield takeEvery(FETCH_EMPLOYEE_ROLE_AUTHORITY_LIST, fetchEmployeeRoleAuthorityList, app);
}

function* fetchEmployeeRoleAuthorityList(app) {
  const { user } = yield select();

  if (user.is_admin) return;

  const { data: roleAuthority } = yield call(
    apiEntity.getEmployeeRoleAuthority,
    app,
    user.id,
  );
  yield put(setUserRoleAuthorityList(roleAuthority));
}

function* fetchAddressType(app) {
  yield takeEvery(FETCH_ADDRESS_TYPE_LIST, fetchAddressTypeList, app);
}

function* fetchAddressTypeList(app) {
  const { data } = yield call(apiCommon.queryDocs, app, DOCTYPE_ADDRESS_TYPE, {
    limit: 10000,
  });

  yield put(setAddressTypeList(data));
}

function* fetchCountry(app) {
  yield takeEvery(FETCH_COUNTRY_LIST, fetchCountryList, app);
}

function* fetchCountryList(app) {
  const { data } = yield call(apiCommon.queryDocs, app, DOCTYPE_COUNTRY, {
    limit: 10000,
  });

  yield put(setCountryList(data));
}
